import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-transfer-placeholder-action',
  templateUrl: './transfer-placeholder-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class TransferPlaceholderActionComponent {
  @Input() touchId!: string;
  @Input() content: any[] = [];
  @Input() quantitySelected = 0;

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private productsService: ProductsService,
    private alertService: AlertService,
  ) {}

  onTransfer(): void {
    const postAssetIds = this.getSelectedPostAssetIds();
    this.transferAssets(postAssetIds);
  }

  private getSelectedPostAssetIds(): string[] {
    return this.content
      .filter((touch: any) => touch.id === this.touchId)
      .flatMap((touch: any) => touch.assets)
      .filter((asset: any) => asset.selected)
      .map((asset: any) => asset.id);
  }

  private transferAssets(postAssetIds: string[]): void {
    this.productsService
      .transferAssetPlaceholder({ postAssetIds }, 'postAssets')
      .subscribe(() => {
        this.alertService.successToast('Transfer successfully!');
      });
  }
}
